import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";
import { RenewalReportingResponse } from "@/types/RenewalReporting";

export const renewalReportingSlice = createApi({
	reducerPath: "renewalReportingSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["renewalReporting"],
	keepUnusedDataFor: 0,
	endpoints: builder => ({
		getRenewalReporting: builder.query<RenewalReportingResponse, void>({
			query: () => ({
				url: `/reporting/renewal`,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				keepUnusedDataFor: 0,
			}),
		}),
	}),
});

export const { useGetRenewalReportingQuery } = renewalReportingSlice;
